import React from 'react';
import PageLayout from '../components/PageLayout';
import HeroSlider from '../components/sections/HeroSlider';
import AboutSection from '../components/sections/AboutSection';
import TriangleSection from '../components/sections/TriangleSection';
import PillarsSection from '../components/sections/PillarsSection';
import ServicesSection from '../components/sections/ServicesSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import ContactSection from '../components/sections/ContactSection';

const HomePage = () => {
  return (
    <PageLayout pageSlug="home">
      <HeroSlider />
      <AboutSection />
      <TriangleSection />
      <PillarsSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
    </PageLayout>
  );
};

export default HomePage;
